
import { extend, configure } from 'vee-validate';
import { required, email, min, max, numeric } from 'vee-validate/dist/rules';
import i18n from './../i18n';

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    values._field_ = i18n.t(`fields.${field}`);
    return i18n.t(`validation.${values._rule_}`, values);
  }
});

// Install required rule and message.
extend('required', required);

// Install email rule and message.
extend('email', email);

// Install min rule and message.
extend('min', min);

// Install min rule and message.
extend('max', max);

// Install min rule and message.
extend('numeric', numeric);

extend('organizationID', {
  validate(value, { country, type, fieldName }) { // eslint-disable-line no-unused-vars
    //console.log(fieldName);
    if (country == 'ec') {
      //https://medium.com/@bryansuarez/c%C3%B3mo-validar-c%C3%A9dula-y-ruc-en-ecuador-b62c5666186f
      //https://www.jybaro.com/blog/cedula-de-identidad-ecuatoriana/
      if (type == 'provider') {
        //const coeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];
        return value.length == 13;
      }
    } else if (country == 'pe') {
      //https://jsfiddle.net/marianom/wphzep59/3/
      if (
        !(
          (value >= 1e10 && value < 11e9) ||
          (value >= 15e9 && value < 18e9) ||
          (value >= 2e10 && value < 21e9)
        )
      )
        return false;

      for (
        var suma = -(value % 10 < 2), i = 0;
        i < 11;
        i++, value = (value / 10) | 0
      )
        suma += (value % 10) * ((i % 7) + ((i / 7) | 0) + 1);
      return suma % 11 === 0;
    } else return false;
  },
  params: ['country', 'type', 'fieldName']
});
